import { useMutation } from '@apollo/client'

import { VerifyOtpForUpdatingUserPinParams } from '@flowwai-frontend/bps-officer-web/graphql'
import {
   convertToErrorType,
   CustomError,
   getAPIStatus
} from '@flowwai-frontend/shared-web/common/data-access'

import {
   VerifyOtpForUpdatingUserPinMutation as Mutation,
   VerifyOtpForUpdatingUserPinDocument as MutationDocument,
   VerifyOtpForUpdatingUserPinMutationVariables as MutationVariables
} from './mutation.generatedTypes'
import useAPIResponseHandler from './responseHandler'

export interface FailureArgsType {
   data?: CustomError<Mutation['verifyOtpForUpdatingUserPin']>
   error?: Error | null
}

interface TriggerAPIArgsType {
   requestObj: VerifyOtpForUpdatingUserPinParams
   onFailure?: (args: FailureArgsType) => void
   onSuccess?: () => void
}

export const useVerifyOtpForSigningPin = () => {
   const [verifyOtpForUpdatingUserPin, { error, loading }] = useMutation<
      Mutation,
      MutationVariables
   >(MutationDocument)

   const { handleAPIResponse } = useAPIResponseHandler()

   const triggerAPI = (args: TriggerAPIArgsType): void => {
      verifyOtpForUpdatingUserPin({
         fetchPolicy: 'network-only',
         variables: {
            params: args.requestObj
         },
         onError: error => {
            args.onFailure?.({ error })
         },
         onCompleted: data =>
            handleAPIResponse({
               data,
               onSuccess: args.onSuccess,
               onFailure: (errorMessage, data) =>
                  args.onFailure?.({
                     data: new CustomError(errorMessage, data)
                  })
            })
      })
   }

   const apiError = convertToErrorType(error)

   const apiStatus = getAPIStatus({
      isError: Boolean(error),
      isLoading: loading
   })

   return {
      apiError,
      apiStatus,
      triggerAPI
   }
}
